<template>
  <div class="page">
    <navigation :customClickEvent="true" @click="showDetention">天美贷</navigation>
    <div class="landing">
      <section class="content">
        <div class="button" @click="handleDownload">{{ downloadButtonTitle }}</div>
        <DownloadQuestion :config="jumpPosition"/>
        <div class="add-card" @click="showTipPopOver">+ 添加绑卡</div>
      </section>
    </div>
    <img class="pop-over" src="https://static.ndmicro.com/tmd/landing/data-distribution/images/img_popOver.png" v-if="showPopOver">
    <download-cover v-if="isShowMask" />
    <ios-download v-model="downloadVisible"></ios-download>
    <ios-wxmp-dialog v-model="iosWxmpQRCodeDialogVisible"></ios-wxmp-dialog>
    <ios-wxmp-link-dialog v-model="iosWxmpLinkDialogVisible"></ios-wxmp-link-dialog>
    <web-clip-pop v-model="webclipPopVisible" @onClose="webclipPopVisible=false"/>
    <web-clip-copy-pop v-model="copyPopVisible" @onClose="copyPopVisible=false"/>
    <nd-dialog
      class="question-dialog"
      v-model="questionDialog"
      :closeBtn="true"
      @click="questionDialog=false"
      :footer="false"
    >
      <div class="question">
        <div class="copy-btn" @click="copyAndroidDownloadLink" data-sensors-click>
          <img src="https://static.ndmicro.com/tmd/landing/data-distribution/images/icon_copyLink.png">
          <span>复制下载链接</span>
        </div>
      </div>
    </nd-dialog>
    <nd-dialog
      class="detention-dialog"
      v-model="detentionVisible"
      :closeBtn="true"
      :footer="false"
    >
      <div class="detention">
        <div class="confirm-btn" @click="detentionGetAmount">去拿5万额度</div>
        <div class="cancel" @click="detentionVisible=false">放弃好运</div>
      </div>
    </nd-dialog>
  </div>
</template>

<script>
import DownloadCover from '@/components/download-cover'
import { judgeClientSystem, isWxMiniprogram, isBaiduMiniprogram } from '@/assets/utils'
import IosDownload from '@/components/ios-download'
import IosWxmpDialog from '@/components/ios-wxmp-qrcode-dialog'
import IosWxmpLinkDialog from '@/components/ios-wxmp-link-dialog'
import isIntercept from '@/assets/intercept-mixin'
import WebClipPop from '../components/web-clip-pop.vue'
import WebClipCopyPop from '../components/web-clip-copy-pop.vue'
import DownloadQuestion from '../components/downloadQuestion.vue'
export default {
  name: 'landingGeneralResult',
  components: {
    DownloadCover,
    IosDownload,
    WebClipPop,
    WebClipCopyPop,
    IosWxmpDialog,
    IosWxmpLinkDialog,
    DownloadQuestion
  },
  data () {
    return {
      home: this.$route.query.home, // 是否直接跳转首页，值为T
      auto: this.$route.query.auto, // 是否自动下载，值为T
      isIos: judgeClientSystem() === 'IOS',
      downloadVisible: false,
      iosWxmpQRCodeDialogVisible: false,
      iosWxmpLinkDialogVisible: false,
      showPopOver: false,
      questionDialog: false,
      detentionVisible: false,
      channel: '',
      webclipPopVisible: false,
      copyPopVisible: false
    }
  },
  async created () {
    this.$bus.$emit('ready')
    this.channel = this.$route.query.channel || this.$storage.get('channel') || 'official'
    await isIntercept(this.channel)
    if (window && window.my && window.my.getEnv) {
      window.my.getEnv(function (res) {
        if (res.miniprogram) { // 当前是小程序环境，postMessage到webview执行跳转
          window.my.postMessage({
            actionType: 3,
            url: location.href
          })
        }
      })
    }
    if (this.auto === 'T' && !this.isShowMask) {
      this.handleDownload()
    }
  },
  computed: {
    downloadButtonTitle () {
      if (isWxMiniprogram() || isBaiduMiniprogram()) {
        return '点击复制链接到浏览器打开'
      }
      return '立即领取额度'
    }
  },
  methods: {
    handleDownload () {
      this.$report({
        id: 50019,
        args: {
          target: 'GENERAL_RESULT5'
        }
      })
      this.downloadApp()
    },
    
    copyAndroidDownloadLink () {
      this.copyUrlAndToast()
    },
    showDetention () {
      this.detentionVisible = true
      this.$sensors.track('PopupDisplay', { msg_name: '返回挽留弹窗' })
    },
    detentionGetAmount () {
      this.detentionVisible = false
      this.handleDownload()
    },
    showTipPopOver () {
      if (this.showPopOver) { return }
      this.showPopOver = true
      setTimeout(() => {
        this.showPopOver = false
      }, 2000)
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";


@keyframes rotate {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes popOverAlpha {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.landing {
  height: 1805px;
  background-image: image-set(url(https://static.ndmicro.com/tmd/landing/data-distribution/images/img_result_background@1x.png) 1x, url(https://static.ndmicro.com/tmd/landing/data-distribution/images/img_result_background@2x.png) 2x);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  padding-top: 768px;
  .content {
    width: 100%;
    margin: 0 auto;
    .button {
      width: 570px;
      height: 94px;
      line-height: 94px;
      text-align: center;
      font-size: 40px;
      color: white;
      margin: 0 auto;
      font-weight: bold;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      box-shadow: 0px 14px 20px 4px #FCD4CF;
      border-radius: 47px;
      animation: rotate 1s linear infinite;
    }
    .question {
      font-size: 24px;
      font-weight: 400;
      color: #FF4633;
      height: 33px;
      line-height: 33px;
      text-align: center;
      margin-top: 30px;
      img {
        padding-left: 5px;
      }
    }

    .add-card {
      width: 690px;
      height: 94px;
      background: #FFFFFF;
      box-shadow: 0px 14px 20px 0px rgba(219,219,219,0.5);
      border-radius: 20px;
      font-size: 32px;
      font-weight: 400;
      color: #283D7D;
      line-height: 94px;
      text-align: center;
      margin: 265px auto;
    }
  }
}

.pop-over {
      width: 319px;
      height: 70px;
      position: relative;
      bottom: 1102px;
      left: 216px;
      animation: popOverAlpha 0.25s ease-in-out;
    }

.question-dialog {
  /deep/.default-content {
    padding-top: 0;
  }
  .question {
    background-image: url(https://static.ndmicro.com/tmd/landing/data-distribution/images/img_question_pop.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    width: 620px;
    height: 650px;
    padding-top: 505px;
    .copy-btn {
      width: 440px;
      height: 80px;
      background: linear-gradient(90deg, #4C6FE4 0%, #A0B5FF 100%);
      box-shadow: 0px 14px 20px 4px #E8EDFF;
      border-radius: 40px;
      font-size: 36px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 80px;
      text-align: center;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 40px;
        height: 40px;
      }
      span {
        padding-left: 10px;
      }
    }
  }
}

.detention-dialog {
  /deep/.default-content {
    padding-top: 0;
  }

  .detention {
    background-image: url(https://static.ndmicro.com/tmd/landing/data-distribution/images/img_detention_pop.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    width: 620px;
    height: 680px;
    padding-top: 490px;
    text-align: center;
    .confirm-btn {
      width: 440px;
      height: 80px;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      box-shadow: 0px 14px 20px 4px #FCD4CF;
      border-radius: 40px;
      text-align: center;
      font-size: 36px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 80px;
      margin: 0 auto;
    }
    .cancel {
      font-size: 24px;
      font-weight: 400;
      color: #999999;
      line-height: 33px;
      margin-top: 38px;
    }
  }
}

</style>